var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArtAndArtists = function SvgArtAndArtists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M122.203 168.801c-25.175 0-48.685-11.252-64.501-30.874l.699-.564c15.645 19.409 38.901 30.542 63.803 30.542 32.377 0 61.78-19.127 74.908-48.733l.821.366c-13.272 29.926-42.997 49.263-75.73 49.263M44.347 114.257c-3.279-9.04-4.945-18.549-4.945-28.255 0-45.655 37.144-82.802 82.801-82.802 43.978 0 80.294 34.364 82.679 78.233l-.896.049c-2.359-43.394-38.28-77.386-81.782-77.386-45.16 0-81.903 36.742-81.903 81.905 0 9.604 1.646 19.007 4.893 27.947z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M200.602 120.07c-10.875 0-19.723-8.846-19.723-19.724 0-10.875 8.848-19.723 19.723-19.723 10.876 0 19.723 8.848 19.723 19.723-.001 10.879-8.847 19.724-19.723 19.724m0-38.547c-10.381 0-18.824 8.443-18.824 18.823s8.443 18.826 18.824 18.826 18.825-8.445 18.825-18.826c0-10.379-8.445-18.823-18.825-18.823"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M200.604 107.635a7.295 7.295 0 0 1-7.288-7.288c0-4.018 3.27-7.285 7.288-7.285 4.015 0 7.282 3.268 7.282 7.285.001 4.02-3.267 7.288-7.282 7.288m0-13.675a6.396 6.396 0 0 0-6.389 6.387 6.397 6.397 0 0 0 6.389 6.391c3.521 0 6.386-2.867 6.386-6.391a6.395 6.395 0 0 0-6.386-6.387M50.888 139.794c-7.726 0-14.012-6.286-14.012-14.012 0-7.728 6.286-14.014 14.012-14.014s14.013 6.286 14.013 14.014c-.001 7.726-6.287 14.012-14.013 14.012m0-27.126c-7.231 0-13.113 5.882-13.113 13.114 0 7.23 5.882 13.111 13.113 13.111 7.232 0 13.115-5.881 13.115-13.111-.001-7.232-5.883-13.114-13.115-13.114"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M50.888 131.04a5.264 5.264 0 0 1-5.259-5.258c0-2.9 2.359-5.261 5.259-5.261s5.26 2.36 5.26 5.261a5.265 5.265 0 0 1-5.26 5.258m0-9.621a4.367 4.367 0 0 0-4.361 4.363 4.366 4.366 0 0 0 4.361 4.36 4.366 4.366 0 0 0 4.362-4.36 4.367 4.367 0 0 0-4.362-4.363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "art-and-artists_svg__a",
    x1: 107.326,
    x2: 161.665,
    y1: 72.91,
    y2: 127.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#art-and-artists_svg__a)",
    d: "M132.918 128.525c-16.552 0-30.021-13.469-30.021-30.024 0-16.553 13.468-30.02 30.021-30.02s30.022 13.467 30.022 30.02c0 16.556-13.468 30.024-30.022 30.024m0-56.451c-14.575 0-26.428 11.855-26.428 26.427 0 14.576 11.854 26.432 26.428 26.432 14.572 0 26.43-11.855 26.43-26.432 0-14.571-11.858-26.427-26.43-26.427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "art-and-artists_svg__b",
    x1: 70.922,
    x2: 138.464,
    y1: 73.566,
    y2: 73.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#art-and-artists_svg__b)",
    d: "M136.668 103.021H72.72a1.8 1.8 0 0 1-1.558-.9 1.8 1.8 0 0 1 0-1.796l31.975-55.38c.643-1.111 2.471-1.111 3.113 0l31.974 55.38a1.8 1.8 0 0 1-1.556 2.696m-60.837-3.593h57.724l-28.861-49.991z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "art-and-artists_svg__c",
    x1: 118.555,
    x2: 170.173,
    y1: 27.605,
    y2: 79.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#art-and-artists_svg__c)",
    d: "M137.91 64.191a7.45 7.45 0 0 1-5.307-2.199 7.45 7.45 0 0 1-2.2-5.303c0-2.007.784-3.894 2.203-5.31l9.72-9.723a7.46 7.46 0 0 1 5.308-2.201c2.009 0 3.892.781 5.311 2.201a7.46 7.46 0 0 1 2.196 5.308 7.46 7.46 0 0 1-2.196 5.306l-9.727 9.725a7.46 7.46 0 0 1-5.308 2.196m9.724-21.14a3.89 3.89 0 0 0-2.767 1.146l-9.722 9.726a3.88 3.88 0 0 0-1.149 2.765c0 1.047.408 2.027 1.147 2.764 1.48 1.482 4.06 1.479 5.534.002l9.726-9.725a3.88 3.88 0 0 0 1.146-2.763 3.9 3.9 0 0 0-1.146-2.769 3.89 3.89 0 0 0-2.769-1.146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "art-and-artists_svg__d",
    x1: 55.09,
    x2: 106.725,
    y1: 91.049,
    y2: 142.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#art-and-artists_svg__d)",
    d: "M82.316 135.503a7.46 7.46 0 0 1-5.309-2.198 7.45 7.45 0 0 1-2.198-5.302c0-2.009.781-3.893 2.202-5.313l9.72-9.723a7.47 7.47 0 0 1 5.309-2.198c2.005 0 3.893.781 5.31 2.2a7.46 7.46 0 0 1 2.198 5.308c0 2.005-.78 3.891-2.198 5.306l-9.727 9.725a7.47 7.47 0 0 1-5.307 2.195m9.724-21.141a3.9 3.9 0 0 0-2.769 1.146l-9.72 9.726a3.89 3.89 0 0 0-1.148 2.768c0 1.044.407 2.024 1.146 2.762 1.48 1.482 4.061 1.477 5.532.002l9.731-9.725c.737-.739 1.144-1.72 1.144-2.764s-.407-2.029-1.148-2.767a3.9 3.9 0 0 0-2.768-1.148"
  })));
};
export default SvgArtAndArtists;